import React from "react";
import ReactQuill from "react-quill";
import { InputLabel } from "../../";
import "./textEditor.css";
var modules = {
  toolbar: [["bold", "italic", "underline"], ["image", "link"], [{
    list: "ordered"
  }, {
    list: "bullet"
  }], [{
    indent: "-1"
  }, {
    indent: "+1"
  }], [{
    size: ["small", false, "large", "huge"]
  }], [{
    color: []
  }, {
    background: []
  }], [{
    align: []
  }]],
  clipboard: {
    matchVisual: false
  }
};

var TextEditor = function TextEditor(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      mode = _ref.mode,
      label = _ref.label,
      toolbar = _ref.toolbar;
  // console.log("toolbar", toolbar);
  return [/*#__PURE__*/React.createElement(InputLabel, {
    style: {
      marginBottom: "20px"
    }
  }, label), /*#__PURE__*/React.createElement(ReactQuill, {
    modules: mode !== "view" ? modules : {
      toolbar: false
    },
    placeholder: "Introduce los detalles de la tarea",
    theme: "snow",
    value: value,
    onChange: onChange,
    readOnly: mode === "view"
  })];
};

TextEditor.defaultProps = {
  onChange: function onChange() {},
  value: "",
  mode: "add"
};
export { TextEditor };